import { render, staticRenderFns } from "./mineAttract.vue?vue&type=template&id=3a9a4301&scoped=true"
import script from "./mineAttract.vue?vue&type=script&lang=js"
export * from "./mineAttract.vue?vue&type=script&lang=js"
import style0 from "./mineAttract.vue?vue&type=style&index=0&id=3a9a4301&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9a4301",
  null
  
)

export default component.exports